import React, { useEffect, useState } from 'react'
import ListContainer from '../../../list'
import { Switch } from '../../../../components'
import { Button, Link, makeStyles, Tooltip } from '@material-ui/core';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';
import { useParams } from 'react-router';
import { connect, useDispatch, useSelector } from 'react-redux';
import { GRID_ROWS_PER_PAGE_DEFAULT_OPTION, UPDATE_APIS_FOR_API_GROUPS_SUCCESS } from '../../../../constants';
import { fetchApisForApiGroups } from '../../../../actions/apiGroups';
import { getApiGroupsLoading, getAvailableApisForGroups, getAvailableApisTotalElementsForGroups, getAvailableApisTotalPagesForGroups, getUpdateApisForApiGroups } from '../../../../reducers/apiGroups';
import { FilterByName, HeaderActionButtons } from './controls';
import styles from "./styles";
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import WarningIcon from "@material-ui/icons/Warning";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { getStatusColor, getStatusLabel } from '../../../Api/List/utils';
import { cloneDeep, every, map } from 'lodash';
import { CHANGE_MODE_ADD_ACCESS, CHANGE_MODE_REMOVE_ACCESS } from '..';
import { compose } from 'recompose';

export const Apis = (props) => {
  const {
    setAssignedApis,
    assignedApis,
    setUnAssignedApis,
    setCurrentTab,
    apiGroupUuid,
    changeMode,
    setChangeMode,
    filterByApiName,
    setFilterByApiName,
    selectedRows,
    setSelectedRows,
    availableApisForGroups,
    availableApisTotalElementsForGroups,
    availableApisTotalPagesForGroups,
    isLoading,
    isApisTabDirty,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
  } = props

  const [appliedFilterByApiName, setAppliedFilterByApiName] = useState('');
  const [currentApisRows, setCurrentApisRows] = useState([])

  const [payload, setPayload] = useState({
    page: page,
    size: rowsPerPage,
    name: filterByApiName,
    apiGroupApiAccessStatus: 'ASSIGNED',
  })

  const params = useParams();
  const intl = getI18n(useIntl());
  const dispatch = useDispatch();
  const currentTab = params?.tabName;
  const isCurrentTab = currentTab === 'apis';

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const assignedApisFromApi = changeMode === CHANGE_MODE_REMOVE_ACCESS && availableApisForGroups &&
    availableApisForGroups?.map(api => api?.apiUuid);

  useEffect(() => {
    setAssignedApis(assignedApisFromApi || []);
    setUnAssignedApis(assignedApisFromApi || []);
  }, [availableApisForGroups]);

  useEffect(() => {
    if (isCurrentTab) {
      setPage(0);
      setAssignedApis(assignedApisFromApi || []);
      setUnAssignedApis(assignedApisFromApi || []);
      setCurrentTab('add-api-group-apis-tab');
      setSelectedRows([]);
      setChangeMode(CHANGE_MODE_REMOVE_ACCESS)
      setPayload({
        ...payload,
        apiGroupApiAccessStatus: "ASSIGNED",
      })
    }
  }, [isCurrentTab])

  useEffect(() => {
    const rowsData = map(availableApisForGroups &&
      availableApisForGroups, (item) => ({ uuid: item.apiUuid, ...item }));
    setCurrentApisRows(cloneDeep(rowsData));
  }, [availableApisForGroups])

  const onAccessToggle = (val, uuid) => {
    setAssignedApis(prevAssignedApis =>
      val
        ? [...prevAssignedApis, uuid]
        : prevAssignedApis.filter(apiUuid => apiUuid !== uuid),
    );
  };

  const getListColumns = ({ getI18nFormattedMessage }) => [{
    id: 'name',
    label: getI18nFormattedMessage("label.organization.apiaccess.apiname"),
    minWidth: 200,
    format: (item) => {
      return (
        (<Link underline="none" className={classes.link} href={`/publish/apis/details/${item.apiUuid}`} target='_blank'>
          {item.apiName}
        </Link>)
      )
    },
    value: ({ apiName, apiUuid } = {}) => ({ apiName, apiUuid }),
  },
  {
    id: 'portalStatus',
    label: intl.getI18nMessage('label.state'),
    minWidth: 50,
    value: (item) => {
      const { portalStatus } = item;
      const status = getStatusLabel(portalStatus);
      const statusIconStyle = {
        fill: getStatusColor(portalStatus),
      };
      return (
        <span>
          <FiberManualRecordIcon
            size="0.82em" key={item.apiUuid} style={statusIconStyle} className={classes.statusIcon} />
          {status === 'Deprecated' || status === 'Disabled' ?
            <span> {status}
              <Tooltip
                title={status === 'Deprecated' ?
                  intl.getI18nMessage('label.application.details.deprecated.api.locked')
                  :
                  intl.getI18nMessage('label.application.details.disabled.api.locked')}
                arrow
                placement="top"
              >
                <WarningIcon className={classes.warningIcon} />
              </Tooltip>
            </span>
            :
            <span>{status}</span>
          }
        </span>);
    },
  },
  {
    id: 'apiGroupApiAccessStatus',
    label: getI18nFormattedMessage('label.application.details.apigroups.table.columns.assign.title'),
    minWidth: 50,
    format: (item) =>
    (<Switch
      id={`${item.apiUuid}-access`}
      onChange={(val) => onAccessToggle(val, item.apiUuid)}
      checked={assignedApis?.includes(item.apiUuid)}
    />
    ),
    value: (item) => (item),
  },
  ];

  const isAddAccessMode = changeMode === CHANGE_MODE_ADD_ACCESS;


  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    setPayload({ ...payload, page: newPage })
  };

  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setPayload({ ...payload, size: newRowsPerPage })
  };

  const handleChange = (value, filterType) => {
    switch (filterType) {
      case 'filterByApiName':
        setFilterByApiName(value);
        break;
      default:
        break;
    }
  }

  const onFilterByNameKeyPress = (e) => {
    setAppliedFilterByApiName(filterByApiName);
    if (e.key === 'Enter' && appliedFilterByApiName !== filterByApiName) {
      setPage(0);
      setPayload({ ...payload, name: filterByApiName });
    }
  }

  const handleBlur = () => {
    setAppliedFilterByApiName(filterByApiName);
    if (appliedFilterByApiName !== filterByApiName) {
      setPage(0);
      setPayload({ ...payload, name: filterByApiName });
    }
  }

  useEffect(() => {
    dispatch(fetchApisForApiGroups(apiGroupUuid, {
      page: page,
      size: rowsPerPage,
      name: filterByApiName,
      apiGroupApiAccessStatus: isAddAccessMode ? "NOT_ASSIGNED" : "ASSIGNED",
    }))
  }, [payload])

  const onAssignToggle = () => {
    setAssignedApis([
      ...assignedApis,
      ...selectedRows.filter(uuid => !assignedApis.includes(uuid)),
    ]);
  };

  const onUnAssignToggle = () => {
    setAssignedApis(assignedApis.filter(apiUuid => !selectedRows.includes(apiUuid)));
  };

  const handleAddApis = () => {
    setChangeMode(CHANGE_MODE_ADD_ACCESS);
    setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    setPage(0);
    setPayload({
      ...payload,
      apiGroupApiAccessStatus: "NOT_ASSIGNED",
    })
  }

  const showAddBtn = changeMode === CHANGE_MODE_REMOVE_ACCESS;

  const isApiUpdateSuccess = useSelector(getUpdateApisForApiGroups);

  useEffect(() => {
    if (isApiUpdateSuccess) {
      dispatch({ type: UPDATE_APIS_FOR_API_GROUPS_SUCCESS, payload: "" });
      setChangeMode(CHANGE_MODE_REMOVE_ACCESS);
      setPayload({
        ...payload,
        apiGroupApiAccessStatus: 'ASSIGNED',
      })
    }
  }, [isApiUpdateSuccess])

  const disableAdd = every(selectedRows, uuid => assignedApis?.includes(uuid));
  const disableRemove = every(selectedRows, uuid => !assignedApis?.includes(uuid));

  return (
    <div>
      {
        <ListContainer
          listPageId='add-api-group-apis-list'
          showListHeader={true}
          isLoading={isLoading}
          noResultsMessage={getI18nFormattedMessage('label.no.results')}
          filterAndSortContent={(
            <div className={classes.filtersContainer}>
              <FilterByName
                fieldContainerClass={classes.fieldContainer}
                handleChange={(value) => handleChange(value, 'filterByApiName')}
                name={getI18nFormattedMessage("label.filter")}
                onKeyPress={onFilterByNameKeyPress}
                handleBlur={handleBlur}
                placeholder={intl.getI18nMessage("label.api.name")}
                value={filterByApiName}
              />
              {
                showAddBtn &&
                <Button
                  disabled={isApisTabDirty}
                  id='add-api-group-add-api-button'
                  data-apim-test='add-api-group-add-api-button'
                  className={classes.addApiButton}
                  variant='contained'
                  color='secondary'
                  onClick={handleAddApis}
                >
                  {intl.getI18nMessage("label.api.add")}
                </Button>
              }
            </div>
          )}
          columns={getListColumns({ getI18nFormattedMessage })}
          rows={currentApisRows}
          totalElements={availableApisTotalElementsForGroups}
          totalPages={availableApisTotalPagesForGroups}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          onChangePreviousPage={onChangePreviousPage}
          onChangeNextPage={onChangeNextPage}
          page={page}
          rowsPerPage={rowsPerPage}
          pageClass={classes.listContent}
          pageBodyClass={classes.pageBodyClass}
          pageFilterAndSortClass={classes.pageFilterAndSortClass}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          hasBulkActions={false}
          hasPaginationDisabled={isApisTabDirty || selectedRows.length > 0}
          bulkActionsContent={
            (<HeaderActionButtons
              {...props}
              id={'add-api-group-apis-header'}
              fieldContainerClass={classes.fieldContainer}
              bulkActionsItemsCount={selectedRows.length}
              classes={classes}
              disableAdd={disableAdd}
              disableRemove={disableRemove}
              onAssign={onAssignToggle}
              onUnassign={onUnAssignToggle}
            />)
          }
        />
      }
    </div>
  )
}

const mapStateToProps = ((state) => ({
  isLoading: getApiGroupsLoading(state),
  availableApisForGroups: getAvailableApisForGroups(state),
  availableApisTotalElementsForGroups: getAvailableApisTotalElementsForGroups(state),
  availableApisTotalPagesForGroups: getAvailableApisTotalPagesForGroups(state),
}))

export default compose(
  connect(mapStateToProps),
)(Apis);

Apis.propTypes = {
  setAssignedApis: PropTypes.func,
  assignedApis: PropTypes.array,
  setCurrentTab: PropTypes.func,
  setUnAssignedApis: PropTypes.func,
  apiGroupUuid: PropTypes.string,
  changeMode: PropTypes.string,
  setChangeMode: PropTypes.func,
  filterByApiName: PropTypes.string,
  setFilterByApiName: PropTypes.func,
  selectedRows: PropTypes.array,
  setSelectedRows: PropTypes.func,
  availableApisForGroups: PropTypes.array,
  isApisTabDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  availableApisTotalElementsForGroups: PropTypes.number,
  availableApisTotalPagesForGroups: PropTypes.number,
  page: PropTypes.number,
  setPage: PropTypes.func,
  rowsPerPage: PropTypes.string,
  setRowsPerPage: PropTypes.func,
}